import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import ApiServer from "../ApiServer.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as Html from "../util/Html.ts";
import * as CustomInput from "../util/CustomInput.ts";
import * as libLocation from "../lib/location.ts";
import {getCache,setCurrentBudget,getCurrentBudget,buildTransactionList,buildSummary} from "../server/objects/BudgetBeans.ts";
import * as i18n from "../i18n.ts";
import FizConfig from "../FizConfig.ts";
import * as Storage from "../lib/Storage.ts";
import {getAuthorization} from "../server/Authorization.ts";
import {downloadUrl} from "../lib/FileUtils.ts";
import  "../ui/modal/budgetCategories.ts";
import  "../ui/modal/paymentMethod.ts";
import * as actionMenu from "../widget/action-menu-registry.ts"
import IHasRecurrencyHelper from "../lib/IHasRecurrencyHelper.ts";
import * as DateUtils from "../lib/DateUtils.ts";
import * as FeatureSeen from "../util/FeatureSeen.ts";
import {guessCurrency} from "../lib/Currency.ts";

import Icons from "../svg/Icons.ts";

import TPL_layout from "../budget/budget_layout.mustache";
import TPL_empty from "../budget/budget_empty.mustache";
import TPL_modal_edit from "../budget/budget_edit.mustache";
import TPL_switch from "../budget/budgetswitch.mustache";
import TPL_table from "../budget/budget_table.mustache";
import TPL_table_category from "../budget/budget_table_category.mustache";
import TPL_table_member from "../budget/budget_table_member.mustache";
import TPL_table_paymentMethod from "../budget/budget_table_paymentmethod.mustache";
import TPL_timenav from "../budget/budget_timenav.mustache";
import TPL_budgeting from "../budget/budgeting.mustache";
import TPL_transaction_edit from "../budget/transaction_edit.mustache";
import TPL_transaction_view from "../budget/transaction_view.mustache";
import {initPaneRight} from "../util/PaneRight.ts"
import * as segment from "../tracking-segment.ts";

import TPL_ROUNDPROGRESS from "../budget/round_progress.mustache";

//build system does not support to give const (the 'this'' is not the good one after) so we do it like that
const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();

function comparator(sort,asc){
  function extract(obj,field){
    let res = obj[field];
    if(typeof res==='function'){
      res = res.apply(obj)
    }
    return res;
  }
  return function(a,b){
    let
      aItem = extract(a,sort),
      bItem = extract(b,sort);
    if(aItem==null) return (asc?1:-1)
    if(aItem.compareTo){
      return (asc?1:-1)*aItem.compareTo(bItem);
    }
    if(typeof aItem ==='string'){
      return (asc?1:-1)*aItem.localeCompare(bItem);
    }
    if(aItem instanceof Date){
      aItem = aItem.getTime();
      bItem = bItem.getTime();
    }
    let resultAsc;
    if(aItem===bItem){
      resultAsc = a.metaId<b.metaId?-1:1;
    }else{
      resultAsc = aItem<bItem?-1:1;
    }

    return asc?resultAsc:-resultAsc;
  }

}

type BudgetView = {
  view:'list'|'paymentMethod'|'members'|'categories',
  sort:'startDate'|'budgetCategory'|'percent'|'limit'|'lastDate'|'amount'|'relatedAccountId'|'paymentMethodId',
  filter:{
    category ?:any[]
    member ?:any[]
    paymentMethod ?:any[]
  },
  sortAsc:boolean,
  date:Date
  pushCategorylimit:boolean,
  budgeting?:boolean,
  defaultAdd:{
    budgetCategoryId?:string
    paymentMethodId?:string
    relatedAccountId?:string
  },
  highlight?:string
  tableaddmode:boolean
}

var
  view :BudgetView = {
    view:'list',
    sort:"startDate",
    filter:{},
    sortAsc:true,
    date:new Date(),
    pushCategorylimit:true,
    budgeting:undefined,
    defaultAdd:{},
    tableaddmode:false
  };

function getDefaultAdd(){
  var
    category = FwDatas.get(view.defaultAdd.budgetCategoryId) || budgetCategoryCache.filtered().find(cat=>cat.default),
    paymentMethod = FwDatas.get(view.defaultAdd.paymentMethodId) || budgetPaymentMethodCache.filtered().find(cat=>cat.default);

  return {
    startDate:view.date,
    amount:0,
    budgetTransactionType:category.budgetTransactionType,
    relatedAccountId:view.defaultAdd.relatedAccountId || FwDatas.getUser().accountId,
    recurrencyDescriptor:new ApiServer.types.RecurrencyDescriptor({recurrency:'NONE'}),
    budgetCategoryId:category.metaId,
    paymentMethodId:paymentMethod.metaId,
  }
}
amplify.subscribe('tableaddmode',function(val){
  view.tableaddmode= val;
})
actionMenu.register({
  budget(){
    var
      budget = getCurrentBudget(),
      actions;
    if(budget.rights.canUpdate){
      actions = [
      {onclick:'budgetedit',svg:Icons.budget.ic_budget_settings,i18nkey:'budget.actions.settings'},
      {onclick:'budgetcategorymanage',svg:Icons.ic_manage_tag,i18nkey:'budget.actions.category'},
      {onclick:'budgetpaymentmethodmanage',svg:Icons.budget.ic_manage_account,i18nkey:'budget.actions.payment'},
      budgetCache.datas.length<2?{onclick:'budgetcreate',svg:Icons.ic_budget,i18nkey:'budget.actions.create'}:{onclick:'budgetopenswitch',svg:Icons.ic_switch,i18nkey:'budget.actions.switch'},
      {onclick:'budgeterasedata',svg:Icons.ic_delete,i18nkey:'budget.actions.erasedata','color':'var(--red)'}
      ]
    }else{
      actions = [
      budgetCache.datas.length<2?{onclick:'budgetcreate',svg:Icons.ic_budget,i18nkey:'budget.actions.create'}:{onclick:'budgetopenswitch',svg:Icons.ic_switch,i18nkey:'budget.actions.switch'}
      ]
    }
    actions.push({onclick:'budgetexportcsv',svg:Icons.ic_export,i18nkey:'budget.actions.export'})
    return {'menu':actions}
  },
  budgetswitch(){
    var
      currentBudgetId = getCurrentBudget()?.metaId,
      result = [];
    budgetCache.datas.forEach(budget=>{
      var svgend = budget.metaId===currentBudgetId?Icons.ic_checkmark:undefined
      result.push({'emoji':budget.emoji,'title':budget.name,onclick:'budgetswitch|'+budget.metaId,svgend})
    });
    result.push({svg:Icons.ic_add_plus,i18nkey:'budget.actions.create',onclick:'budgetcreate'});
    return {menu:result};
  },
  budgetswitchbalance(){
    var result = [];
    result.push({svg:Icons.budget.ic_balance,i18nkey:'budget.summary.balance',onclick:'budgetswitchbalance|range',svgend:Storage.localGet('budget.balance')==='range'?Icons.ic_checkmark:undefined});
    result.push({svg:Icons.calendar.ic_calendar,i18nkey:'budget.summary.balanceToday',onclick:'budgetswitchbalance|today',svgend:Storage.localGet('budget.balance')==='today'?Icons.ic_checkmark:undefined});
    return {menu:result};

  },
  budgetlimitmanage(){
    var
      metaId = Html.getDomMetaId(this),
      budget = budgetCache.get(metaId);
    return {menu:[
      {svg:Icons.ic_edit,i18nkey:'budgetlimit.actions.edit',onclick:'budgetedit||budgetLimit|hideskip'},
      budget.budgetLimitActive?{svg:Icons.ic_block,color:'var(--red)',i18nkey:'budgetlimit.actions.disable',onclick:'budgetlimitactive|false'}:
      {svg:Icons.ic_block,i18nkey:'budgetlimit.actions.enable',onclick:'budgetlimitactive|true'},
    ]}
  },
  budgetlimitcategorymanage(){
    var
      metaId = Html.getDomMetaId(this),
      budget = budgetCache.get(metaId);
    return {menu:[
      {svg:Icons.ic_edit,i18nkey:'budgetlimit.actions.enableonecategory',onclick:'budgetedit||budgetCategoryLimits'},
      budget.budgetLimitCategoryActive?{svg:Icons.ic_block,color:'var(--red)',i18nkey:'budgetlimit.actions.disablecategory',onclick:'budgetlimitcategoryactive|false'}:
      {svg:Icons.ic_block,i18nkey:'budgetlimit.actions.enablecategory',onclick:'budgetlimitcategoryactive|true'},
    ]}
  },
  transactionMenu(){
    var
      metaId = Html.getDomMetaId(this),
      isModal = this.closest('.modal')!==null,
      transaction = FwDatas.get(metaId),
      menu = [];

    if(transaction.rights.canUpdate){
      menu.push({onclick:'transactionedit',svg:Icons.ic_edit,i18nkey:'budget.actions.transactionedit'})
    }
    if(!isModal){
      menu.push({onclick:'transactionview',svg:Icons.ic_info,i18nkey:'actions.seedetails'})
    }
    if(transaction.isPaid()){
      menu.push({onclick:'transactionmarkpaid|false',svg:Icons.budget.ic_unpaid,i18nkey:'budget.actions.markunpaid'})
    }else{
      menu.push({onclick:'transactionmarkpaid|true',svg:Icons.budget.ic_paid,i18nkey:'budget.actions.markpaid'})
    }
    menu.push({onclick:'transactioncopy',svg:Icons.ic_copy_one,i18nkey:'budget.actions.transactioncopy'})

    if(transaction.rights.canDelete){
      menu.push({'color':'var(--red)',onclick:'transactiondelete',svg:Icons.ic_delete,i18nkey:'budget.actions.transactiondelete'})
    }
    return {
      'menu':menu
    }
  }
})
//the undo of the toast marks it back
async function markPaid(metaId :string, paid :boolean){
  const marking = ApiServer.budgetmarkaspaid([metaId],paid);
  amplify.publish("budgetNeedRefresh")
  await marking;
  if(await modal.toastUndo({svg:Icons.ic_done,text:paid?'budget.transactionpaid':'budget.transactionunpaid'})){
    markPaid(metaId,!paid)
  }
}

const budgetClickHandler :namedOnclick = ({
  budgetopenswitch(){
    document.querySelector('#budgetswitch [data-widget="widget/action-menu"]').dispatchEvent(new Event('click'))
  },
  budgetnavtoday(){
    view.date = new Date();
    amplify.publish("budgetViewChange")
  },
  budgetnavnext(){
    view.date = getCurrentBudget().getRange(view.date).next;
    amplify.publish("budgetViewChange")
  },
  budgetnavprev(){
    view.date = getCurrentBudget().getRange(view.date).prev;
    amplify.publish("budgetViewChange")
  },
  budgetedit(metaId,targetfield,wanachangeInfo){
    if(!metaId){
      metaId = Html.getDomMetaId(this)
    }
    if(!metaId){
      metaId = getCurrentBudget().metaId
    }
    var budget = FwDatas.get(metaId);
    if(!budget.rights.canUpdate){
      modal.alert('fw2.apierrors.506')
      return;
    }
    var theModal = modal.openDomModal(TPL_modal_edit,FwDatas.get(metaId))
    if(targetfield){
      setTimeout(()=>{
        const field = theModal.querySelector('[name='+targetfield+']');
        if(field){
          field.dispatchEvent(new CustomEvent('wanachange', {detail: wanachangeInfo, bubbles: true}));
        }
      },50)
    }
  },
  budgetdelete(metaId){
    if(!metaId){
      metaId = Html.getDomMetaId(this)
    }
    askDeleteBudget(metaId,modal.closeDomModal);

  },
  budgetview(name,value,filterMetaId){
    if(name==='sort'){
      if(value===view[name]){
        view.sortAsc = !view.sortAsc;
      }else{
        view[name] = value;
        view.sortAsc = true;
      }
    }else if(name==='filter'){
      view.filter = {};
      if(value==='category'){
        view.filter.category = [FwDatas.get(filterMetaId)];
      }else if(value==='member'){
        view.filter.member = [FwDatas.getProfile(filterMetaId)]
      }else if(value==='paymentMethod'){
        view.filter.paymentMethod = [FwDatas.get(filterMetaId)]
      }
    }else if(name==='pushCategorylimit'){
      view.pushCategorylimit = (value==='true');

    }else{
      view[name] = value;
    }
    if(name==='filter'){
      view.view = 'list'
    }
    if(name==='view'){
      view.filter = undefined;
    }
    if(name==='budgeting'){
      view.budgeting = value==='true';
    }
    amplify.publish("budgetViewChange")
  },
  budgetcreate(){
    modal.openDomModal(TPL_modal_edit,{emoji:'💰',currencyCode:guessCurrency(),rights:{canShare:true}})
  },
  budgetswitch(metaId){
    setCurrentBudget(metaId);
    view.filter = undefined;
    amplify.publish("budgetViewChange")
  },
  budgetswitchbalance(balance){
    Storage.localSet('budget.balance',balance);
    amplify.publish("budgetViewChange")
  },
  budgeterasedata(metaId){
    if(!metaId){
      metaId = Html.getDomMetaId(this)
    }
    if(!metaId){
      metaId = getCurrentBudget().metaId
    }
    var budget = FwDatas.get(metaId);
    modal.ask({
      title:"budget.actions.erasedata",
      message:"budget.eraseexplain",
      button:[
        {class:'secondary',title:'actions.reset',onclick:function(){
          modal.ask({
            title:"budget.actions.reset",
            message:"budget.resetconfirm",
            button:[{class:'negative',title:'actions.reset',onclick:function(){
              if(budget.recurrencyDescriptor.recurrency==='NONE'){
                ApiServer.budgettransactiondelete(null,budgetTransactionCache.datas.filter(t=>t.budgetId===budget.metaId).map(t=>t.metaId))
              }else{
                let
                  range = IHasRecurrencyHelper.getRange(budget.recurrencyDescriptor.recurrency,view.date,budget.recurrencyStartDay),
                  rangeTransaction = buildTransactionList(range,budgetTransactionCache.datas.filter(t=>t.budgetId===budget.metaId));
                ApiServer.budgettransactiondelete("OnlyOne",rangeTransaction.map(t=>t.metaId))
              }
              amplify.publish("budgetNeedRefresh")
            }},
            {class:'secondary',title:'actions.cancel',action:"modalclose"}]
          })

        }},
        {class:'negative',title:'budget.actions.deleteperm',onclick:function(){askDeleteBudget(metaId)}},
        ]
      })
  },
  transactionmarkpaid(value,metaId){
    markPaid(metaId===undefined?Html.getDomMetaId(this):metaId,value==='true')
  },
  transactionview(metaId){
    if(!metaId){
      metaId = Html.getDomMetaId(this);
    }
    segment.track("Budget Transaction Viewed");

    var
      theModal = modal.openDomModal(TPL_transaction_view,FwDatas.get(metaId),{"budgetRefreshed":function(){
        var transaction = FwDatas.get(metaId)
        theInput.value = transaction.isPaid().toString();
        theInput.dispatchEvent(new Event('ui-change', {bubbles: true}));
      }}),
      theInput = theModal.querySelector('[name=isPaid]') as HTMLInputElement;

    theInput.addEventListener('change',function(){
      Html.triggerbystring(this,'transactionmarkpaid|'+(this.value==='true'))
    })
  },
  async transactiondelete(metaId){
    if(!metaId){
      metaId = Html.getDomMetaId(this);
    }
    var
      mode :string,
      allMode = await ApiServer.budgettransactiondeleteoption(metaId);

    if(allMode.length<2){
      if(!await modal.confirmDelete("budget.transactionconfirmdelete")) return;
      mode = allMode[0]
    }else{
      mode = await modal.askAsPromise({
        title:'budget.deleterecurringtitle',
        message:'budget.deleterecurringtext',
        button:allMode.map(opt=>{return {value:opt, title:'budget.deleterecurring'+opt}})
      })
    }
    if(mode!==undefined){
      var done = ApiServer.budgettransactiondelete(mode,metaId)
      amplify.publish("budgetNeedRefresh")
      await done;
      segment.track("Budget Transaction Deleted");
      modal.closeDomModal();
      modal.snackDone("budget.transactiondeleted")
    }

  },
  transactioncopy(metaId){
    if(!metaId){
      metaId = Html.getDomMetaId(this);
    }
    function Copy(){
      this.metaId=null;
    }
    Copy.prototype = FwDatas.get(metaId);
    modal.openDomModal(TPL_transaction_edit,{
      budget:getCurrentBudget(),
      transaction:new Copy(),
      budgetPaymentMethodList:budgetPaymentMethodCache.filtered(),
      relatedAccountList:FwDatas.getFamily().members
    })

  },

  transactionedit(metaId,focus){
    modal.closeDomModal();
    if(!metaId){
      metaId = Html.getDomMetaId(this);
    }
    var
      transaction = FwDatas.get(metaId);
    if(!transaction.rights.canUpdate){
      Html.trigger(this,"transactionview")
      return;
    }
    var
      editModal = modal.openDomModal(TPL_transaction_edit,{
        budget:transaction.budget(),
        transaction:transaction,
        budgetPaymentMethodList:budgetPaymentMethodCache.filtered(),
        relatedAccountList:FwDatas.getFamily().members
      })
    if(focus){
      setTimeout(function(){
        const form = editModal.querySelector('form') as HTMLFormElement;
        var node = form[focus];
        // Check if element is visible (offsetParent is null for hidden elements)
        if(!(node.offsetParent !== null)){
          const secondaryBtn = editModal.querySelector('.secondary') as HTMLElement;
          if(secondaryBtn) secondaryBtn.click();
        }
        if(node.nodeName==='INPUT'){
          (node as HTMLInputElement).select();
        }else{
          node.focus()
        }
      },125)

    }
  },
  transactioncreate(){
    const budgetTable = document.querySelector('.budget-table');
    const lastBLOCK = budgetTable?.querySelector('tr:last-of-type') as HTMLElement;
    const isEmpty = budgetTable === null;
    const lastBLOCKisForm = lastBLOCK?.classList.contains('budget-table-form');
    const tplData = {
          budget:getCurrentBudget(),
          transaction:getDefaultAdd(),
          budgetCategoryList:budgetCategoryCache.filtered(),
          budgetCategoryGroup:[
            {budgetTransactionType:'EXPENSE',name:i18n.get('budget.expense'),list:budgetCategoryCache.filtered().filter(cat=>cat.budgetTransactionType==='EXPENSE')},
            {budgetTransactionType:'REVENUE',name:i18n.get('budget.revenue'),list:budgetCategoryCache.filtered().filter(cat=>cat.budgetTransactionType==='REVENUE')},
            ],
          budgetPaymentMethodList:budgetPaymentMethodCache.filtered(),
          relatedAccountList:FwDatas.getFamily().members
        };
    if(isEmpty || view.view !== 'list'){
      var
        editModal = modal.openDomModal(TPL_transaction_edit,tplData)
      setTimeout(function(){
        const form = editModal.querySelector('form') as HTMLFormElement;
        (form.amount as HTMLInputElement).select();
      },125)

    }else if(lastBLOCKisForm){
      const textInput = lastBLOCK?.querySelector("input[type='text']") as HTMLInputElement;
      if(textInput) textInput.focus();
    }else{
      import('../budget/budget_inlinetransactionform.mustache').then(TPL=>{
        const parent = lastBLOCK?.parentElement;
        if(parent){
          const newBlock = Html.setHtmlAtEndDom(parent,TPL,tplData);
          const textInput = newBlock.querySelector("input[type='text']") as HTMLInputElement;
          if(textInput) textInput.focus();
        }
      })
    }

  },
  async budgeteducational(type){
    if(type==="safetospend"){
      modal.simple({
        title:"budgetlimit.safetospend",
        message:"budgetlimit.safetospendtext",
        lottie:"images/lottie/face_with_monocle.json",
        button:"actions.gotit"
      })
    }else if(type==="lefttodate"){
      modal.simple({
        title:"budgetlimit.lefttodate",
        message:"budgetlimit.lefttodatetext",
        lottie:"images/lottie/face_with_monocle.json",
        button:"actions.gotit"
      })

    }else if(type==="upcomingpayment"){
      modal.simple({
        title:"budgetlimit.upcomingpayment",
        message:"budgetlimit.upcomingpaymenttext",
        lottie:"images/lottie/face_with_monocle.json",
        button:"actions.gotit"
      })

    }else if(type==="budgethiddencategory"){
      modal.simple({
        title:"catsystem.categorymanagehidden",
        message:"catsystem.categorymanagehidden_edu",
        lottie:"images/lottie/face_with_monocle.json",
        button:"actions.gotit"
      })

    }else if(type==="budgethiddenaccount"){
      modal.simple({
        title:"catsystem.paymentmethodmanagehidden",
        message:"catsystem.paymentmethodmanagehidden_edu",
        lottie:"images/lottie/face_with_monocle.json",
        button:"actions.gotit"
      })

    }else if(type==="budgetmarkaspaid"){
      const metaId = Html.getDomMetaId(this);
      const transaction = FwDatas.get(metaId);
      const buttons = [];
      if(transaction){
        if(transaction.isPaid()){
          buttons.push({title:"budget.actions.markunpaid",value:"false"})
        }else{
          buttons.push({title:"budget.actions.markpaid",value:"true"})
        }
      }
      buttons.push({title:"actions.close",class:"secondary"})
      var what = await modal.askAsPromise({
        title:"budget.actions.markpaid",
        message:"budget.markaspaidedu",
        mediaSize:100,
        svg:Icons.budget.stamp,
        button:buttons
      })
      if(what!==undefined){
        modal.closeDomModal()
        Html.trigger(this,'transactionmarkpaid',[what,metaId])
      }

    } else {
      console.log('bad type '+type)
    }
  },
  budgetlimitactive(val){
    var action = ApiServer.budgetput.prepare({metaId:getCurrentBudget().metaId,budgetLimitActive:val,budgetLimitCategoryActive:val==='false'?false:undefined})
    if(val==='false'){
      modal.ask({title:"budgetlimit.actions.disable",message:"budgetlimit.disabletext",button:[{title:"actions.disable",class:"negative",onclick:action}]})
    }else{
      action()
    }
  },
  budgetlimitcategoryactive(val){
    var action = ApiServer.budgetput.prepare({metaId:getCurrentBudget().metaId,budgetLimitCategoryActive:val})
    if(val==='false'){
      modal.ask({title:"budgetlimit.actions.disablecategory",message:"budgetlimit.disablecategorytext",lottie:"images/lottie/money_with_wings.json",button:[{title:"actions.disable",class:"negative",onclick:action}]})
    }else{
      if(getCurrentBudget().isCategoryLimitValid()){
        action()
      }else{
        Html.triggerbystring(this,"budgetedit||budgetCategoryLimits")
      }
    }
  },
  async budgetexportcsv(){
    segment.track("Budget Export Tapped");
    var
      [budgetList,TPL] = await Promise.all([budgetCache.need(),import("../budget/modal_export.mustache")]),
      form = modal.openDomModal(TPL,{}),
      idInput = form.querySelector("[name=id]") as HTMLSelectElement,
      fromInput = form.querySelector("[name=from]") as HTMLInputElement,
      toInput = form.querySelector("[name=to]") as HTMLInputElement,
      previewTag = document.getElementById('countPreview'),
      buttonSubmit = form.querySelector("[type=submit]") as HTMLButtonElement;

    (form as HTMLFormElement).addEventListener('submit', async function(ev){
      ev.preventDefault();

      const startDate = CustomInput.getDateValue(fromInput);
      const endDate = CustomInput.getDateValue(toInput);
      if(!startDate || !endDate) return;

      var url = await ApiServer.budgetexportcsvurl([idInput.value],startDate,endDate)
      const resp = await fetch(url, {headers: {"Authorization": getAuthorization()}});
      const blob = await resp.blob();
      const blobUrl = URL.createObjectURL(blob);
      downloadUrl(blobUrl, "export.csv");
      URL.revokeObjectURL(blobUrl);
      modal.closeDomModal(form)
    })
    idInput.innerHTML = budgetList.map(budget=>`<option value="${budget.metaId}" >${Html.escape(budget.name)}</option>`).join('');
    idInput.value = getCurrentBudget().metaId;

    function onDateChange(){
      var
        count = 0,
        range = {start:CustomInput.getDateValue(fromInput),end:CustomInput.getDateValue(toInput)};
      //remove this Array.of when multiple budget in
      
      count += budgetCache.get(idInput.value).getTransactionList(range).length
      
      if(previewTag) previewTag.innerHTML = i18n.get("budget.export.preview",""+count);
      buttonSubmit.disabled = count===0;
    }
    function onPickBudget(){
      var
        budget = budgetCache.get(idInput.value),
        defaultRange = budgetCache.get(idInput.value).getRange(view.date);

      if(defaultRange.recurrency==='NONE'){
        var transactionsDate = budget.getTransactionList(defaultRange).map(transaction=>transaction.startDate);
        defaultRange.start = transactionsDate.reduce((prev,next)=>next>prev?prev:next)
        defaultRange.end = transactionsDate.reduce((prev,next)=>next>prev?next:prev)
      }else{
        defaultRange.end = new Date(defaultRange.end.getTime()-1000)
      }
      CustomInput.setDateValue(fromInput, defaultRange.start);
      CustomInput.setDateValue(toInput, defaultRange.end);
      onDateChange();
    }

    idInput.addEventListener('change',onPickBudget)
    fromInput.addEventListener('change',onDateChange)
    toInput.addEventListener('change',onDateChange)
    onPickBudget();
  }

})
Html.registerDom(budgetClickHandler);

function handleBudgeting(){
  [100,200,300,400,500].forEach(timeout=>{
    setTimeout(function(){
      document.querySelectorAll<HTMLElement>('.budget-summary .amount').forEach(domTag=>autoFit(domTag,32))
    },timeout)
  })
}
function askDeleteBudget(metaId :string,callback ?:Function){
  modal.ask({
    title:"budget.actions.deleteperm",
    message:"budget.deleteconfirm",
    button:[{class:'negative',title:'budget.actions.deleteperm',onclick:function(){
      ApiServer.budgetdelete(metaId,function(){
        modal.snackDone('budget.budgetdeleted')
        if(callback) callback();
      })
      amplify.publish("budgetNeedRefresh")
    }},
    {class:'secondary',title:'actions.cancel',action:"modalclose"}]
  })

}


ApiServer.budgetput = ApiServer.budgetput.prepare(function(budget){
  setCurrentBudget(budget.metaId);
  amplify.publish("budgetNeedRefresh")
})
ApiServer.budgettransactionput = ApiServer.budgettransactionput.prepare(function(this: any, transaction){
  //shared by the modal form, the inline line and the copy: no metaId sent means a creation
  const sentMetaId = [].concat(this?.data?.metaId ?? [])[0];
  if(!sentMetaId){
    segment.track("Budget Transaction Created",{
      category_name:transaction.budgetCategory?.()?.name,
      transaction_type:segment.enumValue(transaction.budgetTransactionType)
    });
  }
  view.date = transaction.startDate;
  view.highlight = transaction.metaId;
  view.defaultAdd = {
    relatedAccountId: transaction.relatedAccountId,
    budgetCategoryId: transaction.budgetCategoryId,
    paymentMethodId: transaction.paymentMethodId
  };
  modal.closeDomModal();
  amplify.publish("budgetNeedRefresh")
})

var budgetTableContainer : HTMLElement[];
INR.onPage(INR.URL.BUDGET,function(){
  if(FwDatas.getPermission('budget')!=='OK'){
    libLocation.goTo(INR.URL.ENTER_HOME);
    return;
  }
  initPaneRight()
  budgetTableContainer = [document.querySelector(".budget-table-container")];

  if(libLocation.getURLParam('metaId')){
    setCurrentBudget(libLocation.getURLParam('metaId'))
  }
  INR.subscribe("pageUnload",function(){
    var budget = getCurrentBudget()
    if(budget){
      ApiServer.budgetclose(budget.metaId);
    }
  })
  INR.subscribe("budgetRefreshed budgetViewChange",refreshbugdetDisplay);
  INR.subscribe("mediaDeleted",()=>{amplify.publish("budgetNeedRefresh")})
  if(!FeatureSeen.hasSeen('budget.markaspaid')){
    FeatureSeen.markSeen('budget.markaspaid');
    import('../budget/modal_newfeature_markaspaid.mustache').then(TPL_modal_newfeature=>{
      modal.openDomModal(TPL_modal_newfeature,{})
    })
  }
  amplify.publish("budgetNeedRefresh")
});

function refreshbugdetDisplay(){
  if(budgetCache.datas.length===0){
    Html.setHtml(document.querySelector('.fw-maintable'),TPL_empty,{});
    return;
  }else if(document.getElementById('budgetswitch')===null){
    Html.setHtml(document.querySelector('.fw-maintable'),TPL_layout,{});
    budgetTableContainer = [document.querySelector(".budget-table-container")];
  }
  let
    currentBudget = getCurrentBudget(),
    range = currentBudget.getRange(view.date),
    rangeUntilToday = DateUtils.getRangeUntil(DateUtils.getEndOfDay(new Date()));
  if(currentBudget!=undefined){
    handleBudgeting()
  }


  Html.setHtml(document.getElementById('budgetswitch'),TPL_switch,{current:currentBudget,budgetList:budgetCache.datas});

  let
    rangeTransaction = currentBudget.getTransactionList(range),
    transactionUntilToday = currentBudget.getTransactionList(rangeUntilToday),
    filteredTransaction = viewFilterTransaction(rangeTransaction),
    budgetingData = buildBudgetingData(currentBudget,range,rangeTransaction),
    filteredCategoryList = budgetCategoryCache.filtered(),
    filteredPaymentMethodList = budgetPaymentMethodCache.filtered(),
    fullData :any = Object.assign({},view,{
      range:range,
      budget:currentBudget,
      transactionList:filteredTransaction,
      budgetCategoryList:filteredCategoryList,
      budgetPaymentMethodList:filteredPaymentMethodList,
      relatedAccountList:FwDatas.getFamily().members,
      summary:buildSummary(currentBudget,rangeTransaction),
      summaryToday:buildSummary(currentBudget,transactionUntilToday)
    });
  if(currentBudget.budgetLimitCategoryActive && view.filter && view.filter.category){
    fullData.limit = budgetingData.categoriesById[view.filter.category[0].metaId];
  }
  if(!fullData.limit && view.filter && view.filter.category){
    fullData.pushCategoryLimit = view.pushCategorylimit;
  }
  var viewNode = document.querySelector<HTMLElement>('#budgetingview>*')
  Html.setHtml(viewNode,TPL_budgeting,budgetingData)
  viewNode.setAttribute("data-fw-meta-id",currentBudget.metaId);
  if(range.name){
    Html.setHtml(document.querySelector('.timenav'),TPL_timenav,fullData);
  }else{
    document.querySelectorAll('.timenav').forEach(node=>node.innerHTML='')
  }
  if(view.view==="categories"){
    var budgetTransactionType :any[] = [Object.assign({},view,{
      type:"EXPENSE",
      amount:0,
      categoryMap:{}
    }),Object.assign({},view,{
      type:"REVENUE",
      amount:0,
      categoryMap:{}
    })]
    rangeTransaction.forEach(transaction=>{
      var
        type = budgetTransactionType[transaction.budgetTransactionType==='EXPENSE'?0:1],
        catGroup = type.categoryMap[transaction.budgetCategoryId];
      if(!catGroup){
        catGroup = type.categoryMap[transaction.budgetCategoryId] = {budgetCategory:transaction.budgetCategory(),amount:0,lastDate:new Date('1900-01-01')}
      }
      catGroup.amount += transaction.amount;
      type.amount += transaction.amount;
      if(catGroup.lastDate<transaction.startDate){
        catGroup.lastDate = transaction.startDate
      }
    })
    budgetTransactionType.forEach(type=>{
      type.categoryInfo = Object.values(type.categoryMap);
      type.categoryInfo.forEach(catGroup=>{
        catGroup.percent = (100*catGroup.amount/type.amount);
        catGroup.percentString = catGroup.percent.toFixed(1)+'%';
        catGroup.amountString = currentBudget.formatAmount(catGroup.amount)
        catGroup.limit = budgetingData.categoriesById[catGroup.budgetCategory.metaId];
      })
      type.categoryInfo.sort(comparator(view.sort,view.sortAsc))
    })

    budgetTableContainer = Html.replaceWithDom(budgetTableContainer,TPL_table_category,Object.assign({},view,{budget:currentBudget,budgetTransactionType:budgetTransactionType}));
  }else if(view.view==="members"){
    var budgetTransactionType :any[] = [Object.assign({},view,{
      type:"EXPENSE",
      amount:0,
      membersMap:{}
    }),Object.assign({},view,{
      type:"REVENUE",
      amount:0,
      membersMap:{}
    })]
    rangeTransaction.forEach(transaction=>{
      var
        type = budgetTransactionType[transaction.budgetTransactionType==='EXPENSE'?0:1],
        memberGroup = type.membersMap[transaction.relatedAccountId];
      if(!memberGroup){
        memberGroup = type.membersMap[transaction.relatedAccountId] = {member:transaction.relatedAccount(),amount:0,lastDate:new Date('1900-01-01')}
      }
      memberGroup.amount += transaction.amount;
      type.amount += transaction.amount;
      if(memberGroup.lastDate<transaction.startDate){
        memberGroup.lastDate = transaction.startDate
      }
    })
    budgetTransactionType.forEach(type=>{
      type.memberInfo = Object.values(type.membersMap);
      type.memberInfo.forEach(catGroup=>{
        catGroup.percent = (100*catGroup.amount/type.amount);
        catGroup.percentString = catGroup.percent.toFixed(1)+'%';
        catGroup.amountString = currentBudget.formatAmount(catGroup.amount)
      })
      type.memberInfo.sort(comparator(view.sort,view.sortAsc))
    })
    budgetTableContainer = Html.replaceWithDom(budgetTableContainer,TPL_table_member,Object.assign({},view,{budgetTransactionType:budgetTransactionType}));
  }else if(view.view==="paymentMethod"){
    var budgetTransactionType :any[] = [Object.assign({},view,{
      type:"EXPENSE",
      amount:0,
      itemMap:{}
    }),Object.assign({},view,{
      type:"REVENUE",
      amount:0,
      itemMap:{}
    })]
    rangeTransaction.forEach(transaction=>{
      var
        type = budgetTransactionType[transaction.budgetTransactionType==='EXPENSE'?0:1],
        item = type.itemMap[transaction.paymentMethodId];
      if(!item){
        item = type.itemMap[transaction.paymentMethodId] = {item:transaction.paymentMethod(),amount:0,lastDate:new Date('1900-01-01')}
      }
      item.amount += transaction.amount;
      type.amount += transaction.amount;
      if(item.lastDate<transaction.startDate){
        item.lastDate = transaction.startDate
      }
    })
    budgetTransactionType.forEach(type=>{
      type.itemInfo = Object.values(type.itemMap);
      type.itemInfo.forEach(catGroup=>{
        catGroup.percent = (100*catGroup.amount/type.amount);
        catGroup.percentString = catGroup.percent.toFixed(1)+'%';
        catGroup.amountString = currentBudget.formatAmount(catGroup.amount)
      })
      type.itemInfo.sort(comparator(view.sort,view.sortAsc))
    })
    budgetTableContainer = Html.replaceWithDom(budgetTableContainer,TPL_table_paymentMethod,Object.assign({},view,{budgetTransactionType:budgetTransactionType}));
  }else{
    fullData.transactionList.sort(comparator(view.sort,view.sortAsc))
    budgetTableContainer = Html.replaceWithDom(budgetTableContainer,TPL_table,fullData);
    if(view.tableaddmode){
      Html.triggerbystring(null,'transactioncreate')
      view.tableaddmode = false;
    }
    if(view.highlight){
      var node = document.querySelector('[data-fw-meta-id="'+view.highlight+'"]') as HTMLElement;
      view.highlight = undefined;
      if(node){
        try{
          (node as any).scrollIntoViewIfNeeded({block: "center",behavior :"smooth"});
        }catch(e){
          //not supported by firefox on 2022-12-20
        }

        node.style.backgroundColor="#80FF8040"
        node.style.transition="background-color ease 0.5s"
        setTimeout(()=>{
          node.style.backgroundColor="var(--fwSurface)"
        },500)

      }
    }
  }

  updateSummary(fullData.summary,fullData.summaryToday)
}

function viewFilterTransaction(transactionList){
  if(view.filter){
    if(view.filter.category){
      transactionList = transactionList.filter(transaction=>view.filter.category.indexOf(transaction.budgetCategory())!==-1)
    }
    if(view.filter.member){
      transactionList = transactionList.filter(transaction=>view.filter.member.indexOf(transaction.relatedAccount())!==-1)
    }
    if(view.filter.paymentMethod){
      transactionList = transactionList.filter(transaction=>view.filter.paymentMethod.indexOf(transaction.paymentMethod())!==-1)
    }
  }
  return transactionList;
}
function updateSummary(summary,summaryToday){

  if(Storage.localGet('budget.balance')==='range'){
    document.querySelector('.budget-summary .balance .title').innerHTML = (i18n.get('budget.summary.balance'))
    animAmount(document.querySelector('.budget-summary .balance .amount'),summary.balance)
  }else{
    document.querySelector('.budget-summary .balance .title').innerHTML = (i18n.get('budget.summary.balanceToday'))
    animAmount(document.querySelector('.budget-summary .balance .amount'),summaryToday.balance)
  }

  animAmount(document.querySelector('.budget-summary .revenue .amount'),summary.revenue)
  animAmount(document.querySelector('.budget-summary .expense .amount'),summary.expense)
  animAmount(document.querySelector('.budget-summary .category .amount'),summary.topCategory)
  animAmount(document.querySelector('.budget-summary .payer .amount'),summary.topPayer)

  document.querySelector('.budget-summary .category .title').innerHTML = (i18n.get('budget.summary.category',summary.topCategoryTitle||''))
  document.querySelector('.budget-summary .payer .title').innerHTML = (i18n.get('budget.summary.payer',summary.topPayerTitle||''))

}

class AggregatedDatas{
  totalExpense : number;
  totalRevenue : number;
  expenseToDate : number;
  expenseUpcoming : number;
  revenueToDate : number;
  revenueUpcoming : number;

  constructor(){
    this.totalExpense = 0;
    this.totalRevenue = 0;
    this.expenseToDate = 0;
    this.expenseUpcoming = 0;
    this.revenueToDate = 0;
    this.revenueUpcoming = 0;
  }
}
class BudgetingBean{
  emoji :string
  budgetCategory :any
  aggregatedDatas : AggregatedDatas
  safe :string
  over ?:string
  limit : number;
  limitString :string
  leftToDate :string
  expenseUpcoming :string
  spendRate :string
  percent : number
  stateurl :string
  constructor(budgetbean,range,aggregatedDatas,budgetCategory :any,limit){
    this.emoji = budgetCategory?budgetCategory.emoji:budgetbean.emoji;
    this.budgetCategory = budgetCategory;
    this.aggregatedDatas = aggregatedDatas;
    this.budgetCategory = budgetCategory;
    var safe = limit-aggregatedDatas.totalExpense
    if(safe>=0){
      this.safe = budgetbean.formatAmount(safe)
    }else{
      this.safe = budgetbean.formatAmount(0)
      this.over = budgetbean.formatAmount(-safe)
    }
    this.limit = limit;
    this.limitString = budgetbean.formatAmount(limit);
    this.leftToDate = budgetbean.formatAmount(limit-aggregatedDatas.expenseToDate)
    this.expenseUpcoming = budgetbean.formatAmount(aggregatedDatas.expenseUpcoming)

    this.spendRate = budgetbean.formatAmountRound(limit/range.days);

    this.percent = Math.round(100*aggregatedDatas.totalExpense/limit);
    this.stateurl = 'data:image/svg+xml;base64,'+btoa(Html.mustache(TPL_ROUNDPROGRESS,{
      percent:Math.min(100,this.percent),
      color:"#4784EC",
      endColor:this.percent>100?'#FF0000':undefined,
      cacheKiller:new Date().getTime()
    }));
  }
}
function buildBudgetingData(budgetbean,range,rangeTransactions){
  var
    globalInfo = new AggregatedDatas(),
    endOfToday = new Date(),
    byCategory = {},
    daysOrdered = range.getDays(),
    daysByKey = {},
    todayStartTime = DateUtils.clearTime(new Date()).getTime();

  if(budgetbean.paidUsage ==='PAID'){
    rangeTransactions = rangeTransactions.filter(transaction=>transaction.isPaid())
  }

  daysOrdered.forEach((day,index)=>{
    if(day.date.getTime()==todayStartTime){
      day.now=true;
    }
    daysByKey[day.key]=day;
    day.amount=0;
    if(daysOrdered.length>40){
      if(index===0){
        day.legend = day.date.toLocaleString('fr-FR', {day: 'numeric',month:'numeric'})
      }else if(index===daysOrdered.length-31){// we display 31/12 on the 01/12 because if not it is out of the image
        day.legend = daysOrdered[daysOrdered.length-1].date.toLocaleString(i18n.getSelectedLanguage(), {day: 'numeric',month:'numeric'})

      }else{
        delete day.legend;
      }

    }else if(daysOrdered.length>7){
      if([0,9,19,daysOrdered.length-1].indexOf(index)===-1){
        delete day.legend;
      }
    }
  });

  Object.entries(budgetbean.budgetCategoryLimits).forEach(en=>{
    if(en[1]){
      byCategory[en[0]] = new AggregatedDatas()
    }
  })
  endOfToday.setHours(23);
  endOfToday.setMinutes(59);
  endOfToday.setSeconds(59);
  endOfToday.setMilliseconds(999);

  function increment(aggregatedData,transaction,isGlobal){
    if(transaction.budgetTransactionType==='EXPENSE'){
      aggregatedData.totalExpense += transaction.amount;
      if(transaction.startDate<endOfToday){
        aggregatedData.expenseToDate += transaction.amount;
      }else{
        aggregatedData.expenseUpcoming += transaction.amount;
      }
      if(isGlobal){
        var oneDay = daysByKey[DateUtils.forInputDate(transaction.startDate)]
        if(oneDay) oneDay.amount += transaction.amount;
      }
    }else{
      aggregatedData.totalRevenue += transaction.amount;
      if(transaction.startDate<endOfToday){
        aggregatedData.revenueToDate += transaction.amount;
      }else{
        aggregatedData.revenueUpcoming += transaction.amount;
      }
    }
  }
  rangeTransactions.forEach(transaction=>{
    var catinfo = byCategory[transaction.budgetCategoryId];
    if(!catinfo){
      catinfo = byCategory[transaction.budgetCategoryId] = new AggregatedDatas();
    }
    increment(catinfo,transaction,false);
    increment(globalInfo,transaction,true);
  })
  var
    limit = budgetbean.budgetLimitActive?budgetbean.budgetLimit:globalInfo.totalRevenue,
    beanByCategoryId = {},
    beanCategories = Object.entries(byCategory).map(en=>{
      var
        key=en[0],
        value=en[1],
        limit = budgetbean.budgetCategoryLimits[key]||0,
        resultBean = new BudgetingBean(budgetbean,range,value,budgetCategoryCache.get(key),limit);
      if(limit>0){
        beanByCategoryId[key] = resultBean;
        return resultBean;
      }else{
        return undefined;
      }

    }).filter(budgetingBean=>budgetingBean!==undefined).filter(budgetingBean=>{return budgetingBean.budgetCategory.budgetTransactionType==='EXPENSE'})
  beanCategories.sort((a,b)=>{
    return b.percent-a.percent;
  })
  return {
    range : range,
    budget : budgetbean,
    globalInfo : new BudgetingBean(budgetbean,range,globalInfo,null,limit),
    globalInfoDisplayed : budgetbean.budgetLimitActive && ((range.containsToday && globalInfo.totalExpense>0) || (range.isPast && globalInfo.totalExpense>limit) || range.isFuture),
    categoriesById : beanByCategoryId,
    categories : beanCategories,
    graph:daysOrdered.length?svg({amount:budgetbean.budgetLimit, legend:budgetbean.formatAmount(budgetbean.budgetLimit)},daysOrdered):undefined
  }
}

function animAmount(domTag :HTMLElement,amount){
  amount = amount || 0;
  var
    t = 0,
    orig = Number.parseFloat(domTag.getAttribute('data-amount')),
    budget = getCurrentBudget(),
    formatter = Math.round(amount)===amount?function(amount){return budget.formatAmountRound(amount)}:function(amount){return budget.formatAmount(amount)},
    interval,
    update = function(){
      if(t >= 1){
        clearInterval(interval)
        domTag.innerHTML = (formatter(amount))
      }else{
        domTag.innerHTML = (formatter(t*amount+(1-t)*orig))
      }
      t += 0.1;
    };

  if(domTag){
    interval = setInterval(update,50);
    domTag.innerHTML = formatter(amount)
    domTag.style.transition = 'transform 500ms linear';
    autoFit(domTag,32);
    update()
    domTag.setAttribute('data-amount',amount);
  }

}
function autoFit(domTag,padding){
  var availableWidth = (domTag.parentNode.clientWidth-padding);
  if(domTag.clientWidth>availableWidth){
    domTag.style.transform="scale("+(availableWidth/domTag.clientWidth)+")"
  }else{
    domTag.style.transform="scale(1)"
  }

}
function svg(limit,entries){
  class Coordinate{
    x:number;
    y:number;
    constructor(x,y){
      this.x =x;
      this.y =y;
    }
    toString(){
      return this.x.toFixed(1)+' '+this.y.toFixed(1);
    }
  }

  var
    total = entries.reduce((prev,current)=>{
      var res = prev+current.amount;
      current.amount = res; //because we accumulate
      return res;
    },0),
    max = Math.max(total,limit.amount*1.3,1),
    min = -max/100,
    lastIndex = entries.length-1,
    nowIndex = entries.findIndex(entry=>entry.now),
    heightFactor = 120/max,
    widthFactor = 280/lastIndex,
    coord = function(idx,amount){
      return new Coordinate(10+(idx)*widthFactor,125-amount*heightFactor)
    },
    path0 = entries.map((en,idx)=>coord(idx,0)).join(' L '),
    path1 = entries.map((en,idx)=>coord(idx,en.amount)).join(' L '),
    color = getComputedStyle(document.body).color,
    svg = `<svg viewBox="0 0 300 150" xmlns="http://www.w3.org/2000/svg" data-cache-killer="${new Date().getTime()}">
    <g stroke-linejoin="round" stroke-linecap="join">
      <path stroke-width="1" stroke-linecap="round" stroke="#e7e7e7" d="M${coord(0,0)} L${coord(lastIndex,0)}"/>
      <path stroke-width="1" stroke-linecap="round" stroke="#e7e7e7"  d="M${coord(0,limit.amount)} L${coord(lastIndex,limit.amount)}"/>

      <path stroke-width="0"
        fill="url(#gradColor)">
        <animate attributeName="d"
          from="M${coord(0,0)} L${path0} L${coord(lastIndex,0)}"
          to="M${coord(0,0)} L${path1} L${coord(lastIndex,0)}" dur="0.6s" fill="freeze"/>
      </path>
      <path stroke-width="2"
        stroke="${FizConfig.defaultColor}"
        fill="transparent"
        stroke-linecap="round"
        >
        <animate attributeName="d"
          from="M${path0}"
          to="M${path1}" dur="0.6s" fill="freeze"/>
      </path>
      ${(nowIndex==-1)?'':`<path fill="#fff3"  d="M${coord(nowIndex,min)} L${coord(lastIndex,min)} L${coord(lastIndex,max)} L${coord(nowIndex,max)}"/>`}
    </g>
    <g style="font-family:monospace;font-weight:500;fill:${color};">
      <text x="${coord(0,limit.amount).x}" y="${coord(0,limit.amount).y-5}">${limit.legend}</text>
      ${entries.map((en,idx)=>!en.legend?'':`<text x="${coord(idx,0).x - 5}" y="150" ${en.now?'style="color:blue"':''}>${en.legend}</text>`).join('')}
    </g>
    <defs>
      <linearGradient id="gradColor" x1="0" y1="100%" x2="0" y2="0%">
          <stop offset="0" stop-color="${FizConfig.defaultColor}00"></stop>
          ${total<limit.amount?
          `<stop offset="1" stop-color="${FizConfig.defaultColor}40"></stop>`:
          `<stop offset="${limit.amount/total}" stop-color="${FizConfig.defaultColor}40"></stop>
          <stop offset="${limit.amount/total}" stop-color="#ff000040"></stop>
          <stop offset="1" stop-color="#ff000040"></stop>`
          }
      </linearGradient>
      <linearGradient id="gradOpacity" x1="0" y1="0" x2="100%" y2="0%">
          <stop offset="0.6" stop-opacity="1"></stop>
          <stop offset="0.601" stop-opacity="0.5"></stop>
      </linearGradient>
    </defs>
  </svg>`;

  return URL.createObjectURL(new Blob([svg], {type : 'image/svg+xml'}));

}

